import type { Meal } from '../../domain/types.js';
import { Pill } from './Pill.js';
import type { Tone } from './Pill.js';

/** Cuisine drives the card colour, so the library reads like crates on a stall. */
export const CUISINE_TONE: Record<string, Tone> = {
  italian: 'tomato',
  spanish: 'tomato',
  mexican: 'turmeric',
  indian: 'turmeric',
  american: 'turmeric',
  british: 'herb',
  thai: 'herb',
  chinese: 'plum',
  japanese: 'plum',
  greek: 'sea',
  russian: 'sea',
};

const TONE_VAR: Record<Tone, string> = {
  tomato: 'var(--tomato)', turmeric: 'var(--turmeric)', herb: 'var(--herb)',
  plum: 'var(--plum)', sea: 'var(--sea)', dim: 'var(--chalk-dim)',
};

export function MealCard({
  meal,
  starred,
  own,
  onToggleStar,
  onPick,
}: {
  meal: Meal;
  starred: boolean;
  own: boolean;
  onToggleStar: () => void;
  onPick: () => void;
}): React.JSX.Element {
  const tone = CUISINE_TONE[meal.cuisine] ?? 'dim';
  return (
    <div
      className="meal-card"
      data-meal={meal.id}
      style={{ '--crate': TONE_VAR[tone] } as React.CSSProperties}
    >
      <button type="button" className="meal-card-main" onClick={onPick}>
        <span className="meal-card-name" data-testid="meal-name">{meal.name}</span>
        <span className="meal-card-sub">
          {meal.effortMinutes} min · {meal.costBand}
        </span>
        <span className="meal-card-tags">
          {own ? <Pill tone="herb">Yours</Pill> : null}
          {meal.tags.map((tag) => (
            <Pill key={tag} tone={tag === 'mild' ? 'sea' : tag === 'budget' ? 'herb' : 'dim'}>
              {tag}
            </Pill>
          ))}
        </span>
      </button>
      <button
        type="button"
        className="star"
        aria-pressed={starred}
        aria-label={starred ? `Remove ${meal.name} from favourites` : `Add ${meal.name} to favourites`}
        onClick={onToggleStar}
      >
        {starred ? '★' : '☆'}
      </button>
    </div>
  );
}
